angular.
module("dx.webapp.exam").
constant("DX_IMMERSIVE_READER_SETTING", Object.freeze({
	ALLOW_OVERRIDE: 0,
	ALLOW_ALL: 1,
	DENY_ALL: 2,
}));
